import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactGA from 'react-ga';
import store from 'store';
import config from 'config';
import { toast } from 'react-toastify';

toast.configure({
  autoClose: 3000,
  pauseOnFocusLoss: false,
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
